import { render, staticRenderFns } from "./CompPeopleTourRewardForm.vue?vue&type=template&id=9eeee79a&scoped=true"
import script from "./CompPeopleTourRewardForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CompPeopleTourRewardForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eeee79a",
  null
  
)

export default component.exports